import * as APIURL from "../../../../config/config";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { AxiosError } from "axios";
import React, { useState, useEffect, ChangeEvent } from "react";
import { departmentPops } from "../../../../utils/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default function AddUserChildren() {

    const [registerStatus, setRegisterStatus] = useState('');
    const [accountRegistered, setAccountRegistered] = useState<boolean>(false);
    const [departments, setDepartments] = useState<React.JSX.Element[]>([]);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [loading, setLoadingData] = useState<boolean>(true);

    const defaultAccountValue = {
        first_name : '',
        last_name : '',
        email : '',
        position : '',
        department : 0
    }
    const [accountDetails, setAccountDetails] = useState(defaultAccountValue);

    useEffect(()=>{
        async function getDepartments () {
            const getDepartmentResult : React.JSX.Element[] = []; 
            try{
                const departments = await api.get(APIURL.GET_DEPARTMENT_END_POINT, {headers : {'Authorization' : 'Bearer '+getToken()}});
                 departments.data.forEach((data : departmentPops)=>{
                    getDepartmentResult.push(
                        <option value={data.id} className='text-gray-600'>{data.department_name}</option>
                    )
                 })
                 setDepartments(getDepartmentResult);
                 setLoadingData(false);
            }catch(e){
                const error = (e as AxiosError);

                switch (error.response?.status) {
                    case 401:
                        setDepartments([
                            <option className='text-red-500'>Unauthorized access.</option>
                        ])
                        break;
                    case 404:
                        setDepartments([
                            <option className='text-red-500'>No Department found.</option>
                        ])
                        break;
                    case 500:
                        setDepartments([
                            <option className='text-red-500'>Something went wrong!</option>
                        ])
                        break;
                    default:
                        setDepartments([
                            <option className='text-red-500'>An error occured!</option>
                        ])
                        break;

                }
            }
        }

        getDepartments ();
    }, [])

    function updateAccountData(e : ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>){
        const {name, value} = e.target;

        setAccountDetails({
            ...accountDetails,
            [name] : value
        })
    }

    function registerAccount(){
        setLoading(true);
        setTimeout(async()=>{
           const accIsNotComplete = Object.values(accountDetails).some(value => value === '');
           if(accIsNotComplete){ setLoading(false); return setRegisterStatus('All fields are required!'); }
           try{
                await api.post(APIURL.REGISTER_ACCOUNT_END_POINT, accountDetails, {headers : {'Authorization' : 'Bearer '+getToken()}});
                setRegisterStatus('Account registered!');
                setAccountRegistered(true);
                setLoading(false);
                setAccountDetails(defaultAccountValue);
           }catch(e){
            const error = (e as AxiosError);
            setLoading(false);
            switch(error.response?.status){
                case 400:
                    setRegisterStatus('Email already in used.');
                    break;
                case 401:
                    setRegisterStatus('Unauthorized access.');
                    break;
                case 500:
                    setRegisterStatus('Something went wrong!');
                    break;
                case null:
                    setRegisterStatus('Something went wrong!');
                    break;
            }
           }
        },500);
    }

    return (
        <div className="min-w-[28rem] max-w-[28rem] relative">
            <div className={loading ? 'modal-loader' : 'hidden'}>
                <FontAwesomeIcon className="animate-spin" icon={faSpinner} />
            </div>
            <div className="text-center uppercase font-medium text-gray-600 text-xl">
                Add user
            </div>
            <form>
                <div className={accountRegistered ? 'text-green-600' : 'text-red-500'}>
                    {registerStatus}
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' name="first_name" value={accountDetails.first_name} onChange={updateAccountData} placeholder="First name" />
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' name="last_name" value={accountDetails.last_name} onChange={updateAccountData} placeholder="Last name" />
                </div>
                <div className='input-container'>
                    <input type="Email" className='text-box' name="email" value={accountDetails.email} onChange={updateAccountData} placeholder="Email" />
                </div>
                <div className='input-container'>
                    <input type="text" className='text-box' name="position" value={accountDetails.position} onChange={updateAccountData} placeholder="Position" />
                </div>
                <div className='input-container'>
                    <select className='text-box' name="department" value={accountDetails.department} onChange={updateAccountData}>
                        <option value="" className='text-gray-400'>Select Department</option>
                        {departments}
                    </select>
                </div>
                <div className='input-container'>
                    {isLoading ? (
                        <button type="button" disabled className='button button-disabled'>
                            <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                        </button>
                    ) : (
                        <button type="button" onClick={registerAccount} className='button button-vcc-primary'>
                            Register
                        </button>
                    )}
                </div>
            </form>
        </div>
    )
}